// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ameV","rootNoMargin":"styles_rootNoMargin__37T_z"};